import { VariantProps, cva } from 'class-variance-authority';
import { ChangeEvent, DetailedHTMLProps, ForwardedRef, InputHTMLAttributes, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';
import styles from './Switch.module.scss';

const switchVariants = cva([styles['switch'], 'rounded-full', 'align-top cursor-pointer'], {
    variants: {
        size: {
            sm: ['w-[30px] h-[18px]'],
            normal: ['w-[34px] h-5'],
            lg: ['w-9 h-[22px]'],
        },
        // color: {
        //     primary: ['checked:bg-primary checked:border-primary'],
        //     secondary: ['checked:bg-secondary checked:border-secondary'],
        //     success: ['checked:bg-success-500 checked:border-success-500'],
        //     danger: ['checked:bg-danger-500 checked:border-danger-500'],
        //     warning: ['checked:bg-warning-500 checked:border-warning-500'],
        // },
        disabled: {
            true: ['opacity-50'],
            false: [],
        },
    },
    defaultVariants: {
        size: 'normal',
        disabled: false,
        // color: 'primary',
    },
});

export interface SwitchProps
    extends Omit<DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>, 'size' | 'color'>,
        VariantProps<typeof switchVariants> {
    ref?: ForwardedRef<HTMLInputElement>;
    onCheckedChange?: (checked: boolean) => void;
}

const Switch = forwardRef<HTMLInputElement, SwitchProps>((props, ref) => {
    const { size, disabled, className, onCheckedChange, onChange, ...rest } = props;

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        onChange?.(e);

        onCheckedChange?.(e.target.checked);
    };

    return (
        <input
            {...rest}
            ref={ref}
            type="checkbox"
            disabled={disabled}
            onChange={handleChange}
            className={twMerge(switchVariants({ size, disabled, className }))}
        />
    );
});

export default Switch;
